module.exports = "/assets/d2fda985fcf111f3870aa2cc3e652536.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/GV.png
// module id = 2544
// module chunks = 0